/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import QRCode from "qrcode";

import * as url from "helper/UrlHelper";
import { postData } from "utils/Gateway";
import { assetImages } from "constants";

const AskPayment = ({
  userid,
  userName,
  userImage = "",
  userEmail,
  onClose,
}) => {
  console.log("AskPayment modal opened for userId:", userid);
  console.log("User Name:", userName);
  console.log("User Email:", userEmail);
  console.log("User Image:", userImage);

  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [amount, setAmount] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [comments, setComments] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [invoiceId, setInvoiceId] = useState("");
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  const handleSendRequest = async () => {
    if (!userid || !amount || !dueDate) {
      alert("Please fill all required fields.");
      return;
    }

    setIsSubmitting(true);

    const requestData = {
      userid,
      amount,
      dueDate,
      comments,
      module: "MOD_CHAT",
    };

    console.log("Request Data:", requestData);

    try {
      const requestUrl =
        url.API_BASE_URL + url.API_REQUEST_PAYMENT + `?token=${token}`;

      const response = await postData(requestUrl, requestData);

      console.log("Response:", response);

      if (response.status && response.invoiceid) {
        const paymentUrl =
          url.FRONTEND_BASE_URL + `/quickpay/${response.invoiceid}`;
        setInvoiceId(response.invoiceid);
        setPaymentSuccess(true);

        // Generate QR code
        try {
          const qrUrl = await QRCode.toDataURL(paymentUrl);
          setQrCodeUrl(qrUrl);
        } catch (qrError) {
          console.error("Error generating QR code:", qrError);
        }
      } else {
        alert("Failed to send payment request.");
      }
    } catch (error) {
      console.error("Error sending payment request:", error);
      alert("An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCopyUrl = () => {
    const paymentUrl = url.FRONTEND_BASE_URL + `/quickpay/${invoiceId}`;
    navigator.clipboard
      .writeText(paymentUrl)
      .then(() => {
        alert("Payment URL copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy URL:", err);
      });
  };

  const handleDownloadQR = () => {
    if (qrCodeUrl) {
      const link = document.createElement("a");
      link.href = qrCodeUrl;
      link.download = `payment-qr-${invoiceId}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleCloseModal = () => {
    console.log("handleCloseModal called");
    setAmount("");
    setDueDate("");
    setComments("");
    setPaymentSuccess(false);
    setInvoiceId("");
    setQrCodeUrl("");

    // Trigger onClose callback if provided
    if (onClose) {
      console.log("Calling onClose from AskPayment");
      onClose();
    }
  };

  return (
    <div
      className="modal fade"
      id="askPaymentModal"
      tabIndex="-1"
      aria-labelledby="askPaymentModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="askPaymentModalLabel">
              {paymentSuccess ? "Payment Request Sent" : "Request Payment"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleCloseModal}
            ></button>
          </div>
          <div className="modal-body">
            {!paymentSuccess ? (
              <>
                <div className="mb-3 text-center">
                  <img
                    src={
                      userImage === ""
                        ? assetImages.defaultUser
                        : url.SERVER_URL + userImage || "default-user-image.png"
                    }
                    alt={userName || "User"}
                    className="rounded-circle"
                    style={{ width: "80px", height: "80px" }}
                  />
                  <h5 className="mt-2">{userName || "Unknown User"}</h5>
                  <p className="text-muted">
                    {userEmail || "No Email Provided"}
                  </p>
                </div>
                <div className="mb-3">
                  <label className="form-label">Amount</label>
                  <div className="input-group">
                    <span className="input-group-text">€</span>
                    <input
                      type="text"
                      className="form-control"
                      value={amount}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setAmount(value);
                        }
                      }}
                      placeholder="Enter amount"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Due Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Comments / Items billed for
                  </label>
                  <textarea
                    className="form-control"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    placeholder="Add comments (optional)"
                  ></textarea>
                </div>
              </>
            ) : (
              <div className="text-center">
                <div className="mb-4">
                  <h6 className="mb-3">Payment URL:</h6>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      value={url.FRONTEND_BASE_URL + `/quickpay/${invoiceId}`}
                      readOnly
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={handleCopyUrl}
                    >
                      <i className="fas fa-copy"></i> Copy
                    </button>
                  </div>
                </div>

                {qrCodeUrl && (
                  <div className="mb-3">
                    <h6 className="mb-3">QR Code:</h6>
                    <img
                      src={qrCodeUrl}
                      alt="Payment QR Code"
                      style={{ width: "200px", height: "200px" }}
                      className="border"
                    />
                    <p className="text-muted mt-2">
                      Scan this QR code to open the payment link
                    </p>
                    <button
                      className="btn btn-outline-primary btn-sm mt-2"
                      onClick={handleDownloadQR}
                    >
                      <i className="fas fa-download"></i> Download QR Code
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={handleCloseModal}
            >
              Close
            </button>
            {!paymentSuccess && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSendRequest}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Request"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AskPayment;
